import React, { Fragment } from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import AccountSupportCenter from "../support/AccountSupportCenter";

const RecruiterSupportPage = () => (
  <Fragment>
    <Breadcrumbs mainTitle="Help & Support" parent="Recruiter" title="Need Help" />
    <Container fluid={true}>
      <AccountSupportCenter variant="recruiter" />
    </Container>
  </Fragment>
);

export default RecruiterSupportPage;
